import { Location } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Event,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { permisosMenuUser } from 'src/app/pages/auth/constants/menuUsers.constant';
import { rolesUsuario } from 'src/app/pages/auth/constants/rolesUsers.constant';
import { SesionUsuario } from 'src/app/pages/auth/interfaces/SesionUsuario.interface';
import { MicrosoftAuthService } from 'src/app/pages/auth/services/microsoft-auth.service';
import { AppState } from 'src/app/pages/auth/state/app.state';
import { selectorSesionUsuario } from 'src/app/pages/auth/state/selectors/login.selector';
import { BaseJwtService } from 'src/app/shared/services/base-jwt.service';

import { MENU_ROUTES } from '../sidebar/constants/MenuRoutes.const';
import { allowedUserRol } from '../sidebar/functions/AllowedUserRol.function';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {
  public focus: any;
  public listTitles: any[] = [];
  public location: Location;
  sidenavOpen: boolean = true;

  photoProfile: any;

  sesionUsuario: SesionUsuario | undefined;

  private selectorLoadingSubscription: Subscription = new Subscription();
  private photoSubscription: Subscription = new Subscription();

  public aspiranteLogueado: boolean = false;
  public rolesUsuario: string[] = [];

  constructor(
    private MicrosoftAuthService: MicrosoftAuthService,
    location: Location,
    private element: ElementRef,
    private router: Router,
    private domSanitizer: DomSanitizer,
    private store: Store<AppState>,
    private _baseJwtService: BaseJwtService
  ) {
    this.selectorLoadingSubscription = this.store
      .select(selectorSesionUsuario)
      .subscribe((sesion: SesionUsuario) => {
        this.sesionUsuario = sesion;
        this.rolesUsuario = sesion.roles ? JSON.parse(sesion.roles) : [];
      });

    this.photo();

    this.location = location;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }
      if (event instanceof NavigationEnd) {
        // Hide loading indicator

        if (window.innerWidth < 1200) {
          document.body.classList.remove('g-sidenav-pinned');
          document.body.classList.add('g-sidenav-hidden');
          this.sidenavOpen = false;
        }
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        console.log(event.error);
      }
    });

    this.aspiranteLogueado = this._baseJwtService.esUsuarioAutenticadoJWT();
  }

  ngOnInit() {
    this.listTitles = MENU_ROUTES.filter((listTitle) => listTitle);
  }

  logout() {
    this.MicrosoftAuthService.logout();
  }

  logoutAspirante() {
    this._baseJwtService.logoutAspirante();
  }

  photo() {
    this.photoSubscription = this.MicrosoftAuthService.photo().subscribe(
      (blob) => {
        var urlCreator = window.URL || window.webkitURL;
        this.photoProfile = this.domSanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(blob)
        );
      }
    );
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

  public allowedUserRol(): boolean {
    return allowedUserRol(this.rolesUsuario, permisosMenuUser.REGISTROS);
  }

  openSearch() {
    document.body.classList.add('g-navbar-search-showing');
    setTimeout(function () {
      document.body.classList.remove('g-navbar-search-showing');
      document.body.classList.add('g-navbar-search-show');
    }, 150);
    setTimeout(function () {
      document.body.classList.add('g-navbar-search-shown');
    }, 300);
  }
  closeSearch() {
    document.body.classList.remove('g-navbar-search-shown');
    setTimeout(function () {
      document.body.classList.remove('g-navbar-search-show');
      document.body.classList.add('g-navbar-search-hiding');
    }, 150);
    setTimeout(function () {
      document.body.classList.remove('g-navbar-search-hiding');
      document.body.classList.add('g-navbar-search-hidden');
    }, 300);
    setTimeout(function () {
      document.body.classList.remove('g-navbar-search-hidden');
    }, 500);
  }
  openSidebar() {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
      this.sidenavOpen = false;
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
      this.sidenavOpen = true;
    }
  }
  toggleSidenav() {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
      this.sidenavOpen = false;
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
      this.sidenavOpen = true;
    }
  }

  ngOnDestroy(): void {
    this.selectorLoadingSubscription.unsubscribe();
    this.photoSubscription.unsubscribe();
  }
}
